export default function AppSection() {
  return (
    <section id="app" className="relative py-16 md:py-20 bg-background-50">
      <div className="w-full px-4 md:px-6">
        <div className="max-w-5xl mx-auto">
          <div className="flex flex-col lg:flex-row items-center gap-8 md:gap-12 bg-gradient-to-br from-primary-50 to-accent-50 rounded-2xl p-8 md:p-12 overflow-hidden relative">
            <div className="absolute top-0 right-0 w-64 h-64 bg-primary-200/30 rounded-full -translate-y-1/2 translate-x-1/4"></div>
            <div className="absolute bottom-0 left-0 w-48 h-48 bg-accent-200/30 rounded-full translate-y-1/2 -translate-x-1/4"></div>

            <div className="relative z-10 flex-1">
              <div className="inline-flex items-center gap-2 px-3 py-1 rounded-full bg-primary-100 text-primary-700 text-xs font-medium mb-4">
                <i className="ri-smartphone-line"></i>
                <span className="whitespace-nowrap">移动端观影</span>
              </div>
              <h2 className="text-2xl md:text-3xl font-heading text-foreground-900 mb-3">
                随时随地，打开即看
              </h2>
              <p className="text-foreground-600 text-sm md:text-base leading-relaxed mb-6">
                豆花视频完美适配移动端浏览器，无需下载安装，打开网页即可畅享电视剧全集和最新电影。
                支持收藏和浏览记录，追剧进度自动同步，换设备也能接着看。
              </p>
              <div className="flex flex-wrap gap-3">
                <a
                  href="#features"
                  onClick={(e) => {
                    e.preventDefault();
                    document.querySelector('#features')?.scrollIntoView({ behavior: 'smooth' });
                  }}
                  className="inline-flex items-center gap-2 px-6 py-3 rounded-full bg-primary-500 text-background-50 font-semibold text-sm hover:bg-primary-600 transition-colors whitespace-nowrap cursor-pointer"
                >
                  <i className="ri-play-circle-line"></i>
                  立即体验
                </a>
              </div>
            </div>

            <div className="relative z-10 flex-shrink-0">
              <div className="w-[220px] h-[400px] md:w-[260px] md:h-[480px] rounded-3xl overflow-hidden bg-background-50 border-4 border-background-50 shadow-lg">
                <img
                  src="https://readdy.ai/api/search-image?query=A%20smartphone%20app%20interface%20mockup%20for%20a%20video%20streaming%20platform%2C%20showing%20a%20grid%20of%20colorful%20movie%20and%20drama%20posters%20with%20Chinese%20text%20placeholders%2C%20warm%20coral%20and%20amber%20accent%20colors%2C%20clean%20modern%20UI%2C%20dark%20phone%20frame%2C%20minimal%20design%2C%20on%20a%20soft%20gradient%20background&width=520&height=960&seq=douhua-app-mockup&orientation=portrait"
                  alt="豆花视频移动端界面预览"
                  className="w-full h-full object-cover"
                />
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}